import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'VbUpdateTranslationParams',
	standalone: false
})
export class VbUpdateTranslationParamsPipe implements PipeTransform {
	public transform(value: string, replacements: Record<string, string>): string {
		for (const key in replacements) {
			value = value.replace(`{${key}}`, replacements[key]);
		}
		return value;
	}
}
